import script from "./ApplicationsView.vue?vue&type=script&setup=true&lang=js"
export * from "./ApplicationsView.vue?vue&type=script&setup=true&lang=js"

import "./ApplicationsView.vue?vue&type=style&index=0&id=2b2a93b6&scoped=true&lang=css"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_269ca4a85a7eca3d5d7c9cc630d4bd5a/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2b2a93b6"]])

export default __exports__